import React, { useEffect, useState } from 'react';
import SplashScreen from './components/splash';
import RouteApp from './routes/route';

const App = () => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowSplash(false);
    }, 1500);
  }, []);

  return (
    <div className="App">
      {showSplash ? <SplashScreen /> : <RouteApp />}
    </div>
  );
};

export default App;
